import { Dispatch } from "redux";
import { ScheduledQualificationsSortEnum } from "../enums/ScheduledQualificationsSortEnum";
import { setSort } from "../ScheduledQualificationsSlice";

interface Props {
    dispatch: Dispatch;
    sort: {
        sortName: ScheduledQualificationsSortEnum;
        isSorted: boolean;
    };
}

export const handleScheduledQualificationsSort = (props: Props) => () => {
    const { dispatch, sort } = props;

    switch (sort.sortName) {
        case ScheduledQualificationsSortEnum.STARTS_AT_ASC:
            dispatch(
                setSort({
                    sortName: sort.isSorted
                        ? ScheduledQualificationsSortEnum.STARTS_AT_ASC
                        : ScheduledQualificationsSortEnum.STARTS_AT_DESC,
                    isSorted: !sort.isSorted,
                }),
            );
            break;
        case ScheduledQualificationsSortEnum.ENDS_AT_ASC:
            dispatch(
                setSort({
                    sortName: sort.isSorted
                        ? ScheduledQualificationsSortEnum.ENDS_AT_ASC
                        : ScheduledQualificationsSortEnum.ENDS_AT_DESC,
                    isSorted: !sort.isSorted,
                }),
            );
            break;
        case ScheduledQualificationsSortEnum.EMPLOYEE_NAME_ASC:
            dispatch(
                setSort({
                    sortName: sort.isSorted
                        ? ScheduledQualificationsSortEnum.EMPLOYEE_NAME_ASC
                        : ScheduledQualificationsSortEnum.EMPLOYEE_NAME_DESC,
                    isSorted: !sort.isSorted,
                }),
            );
            break;
        case ScheduledQualificationsSortEnum.QUALIFICATION_NAME_ASC:
            dispatch(
                setSort({
                    sortName: sort.isSorted
                        ? ScheduledQualificationsSortEnum.QUALIFICATION_NAME_ASC
                        : ScheduledQualificationsSortEnum.QUALIFICATION_NAME_DESC,
                    isSorted: !sort.isSorted,
                }),
            );
            break;
        case ScheduledQualificationsSortEnum.EDUCATOR_NAME_ASC:
            dispatch(
                setSort({
                    sortName: sort.isSorted
                        ? ScheduledQualificationsSortEnum.EDUCATOR_NAME_ASC
                        : ScheduledQualificationsSortEnum.EDUCATOR_NAME_DESC,
                    isSorted: !sort.isSorted,
                }),
            );
            break;
        default:
            break;
    }
};
